import { QRFeedbackContextProps } from "@/contexts/QRFeedbackContext/types";
import { FeedbackReviewPayload } from "@/interface/api/postFeedbackReview/types";
import { FeedbackReview } from "@/types/qr";

import postFeedbackReviewHandler from "@api/postFeedbackReview";

export const FEEDBACK_PREVIEW_INDEX = {
  HOME_SINGLE_CATEGORY: 0,
  HOME_MULTIPLE_CATEGORIES: 1,
  MULTIPLE_CATEGORIES_FORM: 2,
  ADD_INFO: 3,
  THANK_YOU: 4,
};

const updateCategory = (feedBackContext: QRFeedbackContextProps) => {
  const { selectedReviewCategory, setFeedbackReviewData, feedbackReviewData } = feedBackContext;

  const categoriesArr = feedbackReviewData.categories;

  const categoryToUpdate = selectedReviewCategory;

  const foundItem = categoriesArr.findIndex((obj) => obj.id === categoryToUpdate.id);
  categoriesArr[foundItem] = categoryToUpdate;
  setFeedbackReviewData({ ...feedbackReviewData, categories: categoriesArr });
};

export const resetCategoriesAndContactData = (feedBackContext: QRFeedbackContextProps) => {
  const { setFeedbackReviewData, feedbackReviewData } = feedBackContext;

  const emptyFeedbackReview: FeedbackReview = {
    categories: feedbackReviewData.categories.map((category) => ({
      ...category,
      rating: null,
      comment: "",
    })),
    contactData: {
      name: "",
      email: "",
      phone: "",
    },
    createdAt: "",
    id: "",
    rateAverage: 0,
    ratingBase: 0,
    updatedAt: "",
  };
  setFeedbackReviewData(emptyFeedbackReview);
};

const submitDataInPView = (feedBackContext: QRFeedbackContextProps) => {
  const { setCurrentView, setFeedbackReviewData, feedbackReviewData, reviewContactData } =
    feedBackContext;

  setFeedbackReviewData({
    ...feedbackReviewData,
    contactData: reviewContactData,
  });
  setCurrentView(FEEDBACK_PREVIEW_INDEX.THANK_YOU);
};

const submitDataInQRView = async (feedBackContext: QRFeedbackContextProps, pathname: string) => {
  const { setCurrentView } = feedBackContext;

  try {
    const pathParts = pathname.split("/qr/");

    if (pathParts.length > 1) {
      const reference = pathParts[pathParts.length - 1];
      const review: FeedbackReviewPayload = {
        categories: feedBackContext.feedbackReviewData.categories
          .map((category) => ({
            id: category.id,
            comment: category.comment,
            rate: category.rating,
          }))
          .filter((category) => category.rate !== null),
        contactData: {
          name: feedBackContext.reviewContactData?.name || "",
          email: feedBackContext.reviewContactData?.email || "",
          phone: feedBackContext.reviewContactData?.phone || "",
        },
      };

      await postFeedbackReviewHandler.postFeedbackReview({ reference, review });

      setCurrentView(FEEDBACK_PREVIEW_INDEX.THANK_YOU);
    } else {
      throw new Error("No QR Reference");
    }
  } catch (error) {
    throw new Error("Error submitting feedback");
  }
};

const runSubmit = async (feedBackContext: QRFeedbackContextProps, pathname: string) => {
  if (pathname.includes("/qr/")) {
    await submitDataInQRView(feedBackContext, pathname);
  } else {
    submitDataInPView(feedBackContext);
  }
};

export const handleSubmit = async (
  feedBackContext: QRFeedbackContextProps,
  hasMultipleCategories: boolean,
  pathname: string,
  hasAddInfoForm: boolean
) => {
  const { currentView, setCurrentView } = feedBackContext;
  if (currentView === FEEDBACK_PREVIEW_INDEX.THANK_YOU) {
    hasMultipleCategories
      ? setCurrentView(FEEDBACK_PREVIEW_INDEX.HOME_MULTIPLE_CATEGORIES)
      : setCurrentView(FEEDBACK_PREVIEW_INDEX.HOME_SINGLE_CATEGORY);
  } else {
    if (
      currentView === FEEDBACK_PREVIEW_INDEX.HOME_SINGLE_CATEGORY ||
      currentView === FEEDBACK_PREVIEW_INDEX.MULTIPLE_CATEGORIES_FORM ||
      currentView === FEEDBACK_PREVIEW_INDEX.HOME_MULTIPLE_CATEGORIES
    ) {
      updateCategory(feedBackContext);
      if (hasAddInfoForm) {
        setCurrentView(FEEDBACK_PREVIEW_INDEX.ADD_INFO);
      } else {
        await runSubmit(feedBackContext, pathname);
      }
      setCurrentView(
        hasAddInfoForm ? FEEDBACK_PREVIEW_INDEX.ADD_INFO : FEEDBACK_PREVIEW_INDEX.THANK_YOU
      );
    }
    if (currentView === FEEDBACK_PREVIEW_INDEX.ADD_INFO) {
      await runSubmit(feedBackContext, pathname);
    }
  }
};

export const handleSaveAndMore = (feedBackContext: QRFeedbackContextProps) => {
  const { setCurrentView } = feedBackContext;
  updateCategory(feedBackContext);
  setCurrentView(FEEDBACK_PREVIEW_INDEX.HOME_MULTIPLE_CATEGORIES);
};
